export default {
  KYC_2_HEADER:
    "Do any of these special situations apply to you or an immediate family member?",
  KYC_2_SUBHEADING:
    "This is information we are required to collect to verify our customer information.",
  KYC_2_RADIO_ITEMS: [
    {
      label:
        "Associated or employed by a stock exchange, regulatory body, member firm of an exchange, FINRA or a municipal securities broker-dealer?",
    },
    {
      label:
        "An officer, or, a 10% or greater shareholder of a publicly traded company, subject to the US Securities Exchange Act of 1934?",
    },
    {
      label:
        "Currently or formerly a Politically Exposed Person or Public Official?",
    },
  ],
  RADIO_ITEMS: [
    {
      label: "No, none of these apply",
      value: false,
    },
    {
      label: "Yes, some of these apply",
      value: true,
    },
  ],
  KYC_2_BUTTON_HEADING: "Continue",
};
